/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import jwtDecode from 'jwt-decode';

import { RootState } from './redux/store';

export const clearStoredUser = (): void => {
  const persist = localStorage.getItem('persist:root');
  if (persist) {
    const parsedPersist = JSON.parse(persist);
    localStorage.setItem('persist:root', JSON.stringify({ ...parsedPersist, user: null }));
  }
};

export const getUser = () => {
  const persist = localStorage.getItem('persist:root');
  if (!persist) {
    return null;
  }
  const parsedPersist: RootState = JSON.parse(persist);
  return parsedPersist.user;
};

export const checkIfTokenIsValid = (user: RootState['user'] | null): boolean => {
  try {
    if (!user?.accessToken) {
      return false;
    }

    const decodedJwt: { exp: number } = jwtDecode(user.accessToken);
    return decodedJwt.exp >= Date.now() / 1000;
  } catch (error) {
    return false;
  }
};
